export class DatabaseUserAttribute {
    id: number = 0;
    key: string = "";
    value: string = "";
}
